/**
 * Password policy (issue #20). Keep in sync with backend/utils/passwordPolicy.js.
 */
export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'uppercase', label: 'At least 1 uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { id: 'number', label: 'At least 1 number', test: (p) => /[0-9]/.test(p) },
  { id: 'special', label: 'At least 1 special character', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const isPasswordValid = (password) =>
  PASSWORD_RULES.every((rule) => rule.test(String(password || '')));

export const getPasswordRuleResults = (password) =>
  PASSWORD_RULES.map((rule) => ({ ...rule, passed: rule.test(String(password || '')) }));
